import { props, createAction } from '@ngrx/store';

import { Information } from '../../models/registration.model';

export const checkInformation = createAction(
  '[Registration] Check information',
  props<Information>(),
);
export const setInformation = createAction('[Registration] Set information', props<Information>());
